import { Pipe, PipeTransform } from '@angular/core';
import { PatientContactPreferences } from 'src/app/core/models/patient/contactPreferences';

@Pipe({
  name: 'mailContactPreferences'
})
export class MailContactPreferencesPipe implements PipeTransform {

  transform(preferences: PatientContactPreferences[]): string {

    try {
      if (preferences.length == 0) {
        return '';
      }

      const mailContacts = preferences.filter(x => x.contactType.toUpperCase() == 'EMAIL');
      if (mailContacts === undefined) {
        return '';  
      }

      return mailContacts[0].contactValue.toLowerCase();
      
    } catch (error) {
      return '';
    }
  }

}
